<template>
  <section>
    <div class="grid gap-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
      <div v-for="d in data" :key="d.id">
        <a :href="d.url_link" target="_blank">
          <div class="shadow p-2 rounded">
            <img
              :src="baseUrlSrc(d.thumbnail_url)"
              alt=""
              class="rounded-t-lg w-full object-cover md:h-40 h-56"
              @error="defaultImage"
            />
            <div class="flex items-center justify-between mt-2">
              <h5 class="capitalize">{{ d.title }}</h5>
              <span>${{ d.cost }}</span>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div
      v-if="data && data.length == 0"
      class="flex flex-col justify-center items-center text-xl text-gray-700 mt-8 space-y-8"
    >
      <img
        :src="require(`@/assets/svg/store_no_data.svg`)"
        alt="..."
        class="w-72"
      />
      <div class="flex flex-col justify-center items-center text-center">
        <span> Looks like there is nothing here yet.</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    data: Array,
  },
  data() {
    return {};
  },
};
</script>